var map = {
	"./arrow-left.svg": "ecd8",
	"./arrow-right.svg": "1d68",
	"./basket.svg": "4750",
	"./down-white.svg": "7dbf",
	"./down.svg": "640a",
	"./icon-close.svg": "9f16",
	"./location.svg": "c411",
	"./search.svg": "f919"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";